import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import ProductBox from './ProductBox';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const TopDiscountedTechCarousel = () => {
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
  
    useEffect(() => {
      const fetchTopDiscountedProducts = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/main/most-discounted-tech-landing`, {
            // params: { page: 1 }
          });
          setItems(res.data.products || []);
        } catch (err) {
          console.error('Error fetching discounted tech items:', err);
        }
      };
  
      fetchTopDiscountedProducts();
    }, []);
  
    return (
      <div className="slider-container most-discounted">
        <div className="slider-header ">
          <Link to="/most-discounted-tech">
          <h2 className="hover:text-primary text-lg category-title text-[rgb(62,43,205)]">{t('mostDiscountedTechCarousel.title')} <FontAwesomeIcon icon={faExternalLink} className="ml-2" /></h2>
          </Link>
          <p className='text-sm'>{t('mostDiscountedTechCarousel.description')}</p>
          {/* <Link to="/most-discounted" className="see-all">{t('landingPage.seeAll')}</Link> */}
        </div>
        <div className="carousel carousel-center space-x-4 p-4 overflow-x-auto w-full">
          {items.map((item) => (
            <div key={item._id} className="carousel-item px-4 flex justify-center items-stretch">
              <ProductBox product={item} />
            </div>
          ))}
        </div>
      </div>
    );
  };
export default TopDiscountedTechCarousel;
